<div class="mb-5">
  <div class="gb-body3 heavy gb-color-grey-mid-dark mb-4">
    <p class="mb-0" [translate]="'locateDealer_requiredLabel'"></p>
  </div>
  <div [trackLink]="'Dealer:BrandDropdown'" [trackDropdown]="'true'" [trackDelay]="'true'"
        [trackType]="'o'" [prop10]="'dealer:dropdown:'+brands[0]">
      <div>
        <webu-select-input
          [id]="'DealerSearchBrandSelector'"
          [label]="'locateDealer_brandSelector_label'"
          [lov]="brands" 
          [options]= "brands"
          [inputName]="'brandSelectorInput'" 
          [isArray]="true"
          [required]="true"
          [formGroupInput]="dealerSearchForm"
          [formControlNameInput]="'brandSelectorInput'">
        </webu-select-input>
      </div>
  </div>
</div>

<form [formGroup]="dealerSearchForm" role="form" name="dealerSearchForm" novalidate>
  <div [trackLink]="'Dealer:ZipCode'" [trackDelay]="'true'" class="mb-3" [trackType]="'o'" [prop10]="'dealer:textbox'">
    
    <!-- Search Method Selection -->
    <div class="d-flex mb-2">
      <div class="ml-3">
        <input [id]="'city'" 
          (change) = "searchType('city')" 
          type="radio" name="searchMethod" 
          formControlName="searchMethod" 
          [value]="'city'">
        <label [translate]="'locateDealer_searchType_city'"
          [attr.for]="'city'" class="mb-0"></label>
      </div>
      <div class="ml-auto">
        <input [id]="'dealer'" 
          (change)="searchType('dealer')"
          type="radio" name="searchMethod"
          formControlName="searchMethod"
          [value]="'dealer'">
        <label [translate]="'locateDealer_searchType_dealer'"
          [attr.for]="'dealer'" class="mb-0"></label>
      </div>
    </div>

    <!-- Search by City Input -->
    <div class="d-flex flex-column flex-lg-row">
      <div class="d-flex flex-column mr-lg-2 flex-grow-1">
        <ox-text-input [id]="'DealerSearchLocateDealer'" 
          [type]="'text'" [inputName]="'searchInput'"
          [classes]="'form-control'" [required]="true" 
          [placeHolderId]="'locateDealer_search_placeholder'"
          [ariaLabel]="'aoda_locateDealer_search_label'"
          [formGroupInput]="dealerSearchForm"
          [formControlNameInput]="'searchInput'"
          (focused)="setScrolling($event)">
        </ox-text-input>
      </div>
      <!-- Search Button -->
      <span [trackLink]="'Dealer:Search'" [trackDelay]="'true'" [trackType]="'o'"
      class="flex-grow-2" [prop10]="'dealer:button:search'">
        <button type="submit" class="gb-primary-button mt-2 mt-lg-0" (click)="search()"
                [ngClass]="{'disabled': (!dealerSearchForm.valid)}"
                attr.aria-disabled="{{!dealerSearchForm.valid}}"
                aria-atomic="true" aria-live="assertive"
                [translate]="'locateDealer_findDealersBtn'">
        </button>
      </span>
    </div>
  </div>


  <!-- Use My Location -->
<div *ngIf="(myLocationToggle$ | async) === 'true'" >
    <hr class="locate-dealer-separator" [attr.data-content]="'locate_dealer_separator' | translate">
  <div class="row mt-5">
    <div class="col-12 col-lg-6">
      <button type="submit" (click)="useMyLocation()" class="gb-primary-button" [translate]="'locate_dealer_useMyLocation'"></button>
      <p class="gm-error" [hidden]="!geolocationUnsupported"><span class="gb-body1" aria-atomic="true" role="alert" [translate]="'locateDealer_geolocation_unsupported'"></span></p>
    </div>
  </div>
</div>
  
</form>
